import {
	faJs,
	faHtml5,
	faCss3Alt,
	faReact,
	faVuejs,
	faLinux,
	faGitAlt,
	faGithub,
	faDocker,
	faNodeJs,
} from '@fortawesome/free-brands-svg-icons'

const iconsArray = [
	faJs,
	faHtml5,
	faCss3Alt,
	faReact,
	faVuejs,
	faLinux,
	faGitAlt,
	faGithub,
	faDocker,
    faNodeJs
]

export default iconsArray
